import { render } from "./NavbarView.vue?vue&type=template&id=50af45d0&scoped=true"
import script from "./NavbarView.vue?vue&type=script&lang=js"
export * from "./NavbarView.vue?vue&type=script&lang=js"

import "./NavbarView.vue?vue&type=style&index=0&id=50af45d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50af45d0"]])

export default __exports__